import styled from 'styled-components';
import { getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/core';

export const ItemsTableElement = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const ItemsTableRowElement = styled.tr`
    border-bottom: 1px solid ${getToken('borderStaticSecondary')};

    & > :nth-child(1) {
        width: 20%;
    }
    & > :nth-child(2) {
        width: 20%;
        text-align: right;
    }
    & > :nth-child(3) {
        width: 25%;
    }
    & > :nth-child(5) {
        text-align: right;
    }
`;

export const ItemsTableClickableRowElement = styled(ItemsTableRowElement)`
    cursor: pointer;
`;

export const ItemsTableCellElement = styled.td<{ offset?: number }>`
    vertical-align: middle;
    padding: 5px;
    padding-left: ${({ offset, theme }) => (offset != null ? offset : 0) * getSpacingToken('200')({ theme })}px;
`;

export const ItemsTableHeaderCellElement = styled(ItemsTableCellElement).attrs({ role: 'columnheader' })`
    ${getTextTokenPreset('bodySmall')};
`;

export const TitleAndToggleElement = styled.div`
    display: flex;
    align-items: center;
`;

export const TooltipListElement = styled.dl`
    display: grid;
    grid-template-columns: 80px 1fr;
    margin: 0;
`;

export const TooltipLabelElement = styled.dt`
    text-align: left;
    ${getTextTokenPreset('bodySmall')};
`;

export const TooltipValueElement = styled.dd`
    ${getTextTokenPreset('bodySmallStrong')};
`;
